import Icon from '../components/Icon.vue'

Icon.register({"area-chart":{"width":2048,"height":1792,"paths":[{"d":"M2048 1536v128h-2048v-1536h128v1408h1920zM1664 512l256 896h-1664v-576l448-576 576 576z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/area-chart.js
// module id = 319
// module chunks = 0